import { fetchUserAttributes } from 'aws-amplify/auth'

const checkAccountEmailVerified = async (ctx) => {
  if (ctx.serviceUserEmailVerified === true) {
    return {
      context: {
        serviceUserEmailVerified: true,
      },
    }
  }

  const user = await fetchUserAttributes()

  if (user?.email_verified === 'true') {
    return {
      context: {
        serviceUserEmailVerified: true,
      },
    }
  }

  const error = {
    message: 'Please verify your email address.',
  }

  return Promise.reject(error)
}

export default checkAccountEmailVerified
